module.exports = __webpack_public_path__ + "04985d181a44c43b3d0a681e7cded5c9.pdf";